"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseClient = exports.httpDelete = exports.httpPut = exports.httpGet = exports.httpPost = exports.create = void 0;
const query_string_1 = __importDefault(require("query-string"));
let http;
const create = (axiosInstance) => {
    http = axiosInstance;
};
exports.create = create;
const httpPost = (url, data, params, config) => {
    return http.post(url, JSON.stringify(data), {
        params: params,
        paramsSerializer: (params) => query_string_1.default.stringify(JSON.parse(JSON.stringify(params))),
        signal: config === null || config === void 0 ? void 0 : config.signal,
    });
};
exports.httpPost = httpPost;
const httpGet = (url, params, data, config) => {
    return http.get(url, {
        params: params,
        data: data,
        paramsSerializer: (params) => query_string_1.default.stringify(JSON.parse(JSON.stringify(params))),
        signal: config === null || config === void 0 ? void 0 : config.signal,
    });
};
exports.httpGet = httpGet;
const httpPut = (url, data, params, config) => {
    return http.put(url, JSON.stringify(data), {
        params: params,
        paramsSerializer: (params) => query_string_1.default.stringify(JSON.parse(JSON.stringify(params))),
        signal: config === null || config === void 0 ? void 0 : config.signal,
    });
};
exports.httpPut = httpPut;
const httpDelete = (url, params, data, config) => {
    return http.delete(url, {
        params: params,
        data: data,
        paramsSerializer: (params) => query_string_1.default.stringify(JSON.parse(JSON.stringify(params))),
        signal: config === null || config === void 0 ? void 0 : config.signal,
    });
};
exports.httpDelete = httpDelete;
class BaseClient {
    constructor(url) {
        this.url = url;
    }
}
exports.BaseClient = BaseClient;
